<template>
  <v-icon v-if="show" color="teal" @click="$emit('click')">mdi-send</v-icon>
</template>

<script>
export default {
  name: 'WaSendIcon',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
